import { Div } from "ui";
import {  ReactComponent as PlaySVG} from 'assets/player/play.svg'

const IPhoneOverlay = ({ onPlay }) => (
  <Div
    position='absolute'
    role='button'
    top={0}
    left={0}
    width='100%'
    height='100%'
    onClick={onPlay}
    onPointerUp={onPlay}
    backgroundColor='rgba(0,0,0,.7)'
    display='grid'
    placeItems='center'
  >
    <PlaySVG width={60} height={60}/>
  </Div>
)

export default IPhoneOverlay